import { useQueryClient } from "react-query";
import styled from 'styled-components';
import theme from "../../styles/theme";
import moment from "moment";
import Button from "../common/Button";
import InputBox from "../common/InputBox";
import { useRef, useState } from 'react';
import { adminLogin } from "../../interface/auth";


const MainWrap = styled.div`
    width: 100%;
    height: 100vh;
    height: -webkit-fill-available;
    height: fill-available;
    background: ${theme.color.white[100]};
    display:flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
    padding: 2rem;
`;

const LoginCard = styled.div`
    width: calc(30vw - 2rem);
    height: calc(70vh - 2rem);
    min-width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: ${theme.color.primary.main};
    border-radius: 16px;
    border: 0.5px solid ${theme.color.black[10]};
    padding: 1rem;
    transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    h1 {
        margin: 0;
        color: ${theme.color.black[80]};
        font-weight: 800;
    }
    span {
        font-size: 0.8rem;
        color: ${theme.color.secondary.red};
    }
`;


const Login =  () => {

    const queryClient = useQueryClient();

    const pwdRef = useRef(null);

    const [user_no, setUser_no] = useState();
    const [pwd, setPwd] = useState();

    const [comment, setComment] = useState();
    
    const handleLogin = () => {
        if(user_no && pwd){
            adminLogin({user_no,pwd})
                .then((res)=>{
                    if(res && res.data.length>0){
                        const conv = res.data[0]
                        conv.ex_date = moment().add(1,'day').format("yyyyMMDDHHmmss")
                        queryClient.setQueryData('USER',conv);
                        localStorage.setItem('USER',JSON.stringify(conv))
                    }else{
                        setComment('아이디/비밀번호를 확인해주세요')
                    }
                })
                .catch((err)=>{
                    console.log(err)
                    setComment('로그인에 실패 하였습니다. 잠시후 시도해주시기 바랍니다. 이 상황이 지속되면 문의 바랍니다.')
                });
        }else{
            setComment('아이디/비밀번호를 확인해주세요')
        }
    }

    const handleKeydown = (e) => {
        if(e.keyCode === 13) {
            if(e.target.tabIndex === 1){
                pwdRef.current.focus();
            }else if(e.keyCode === 13){
                handleLogin();
            }
        }

    }

    return (
        <MainWrap>
            <LoginCard>
                <h1>TAMS</h1>
                <div style={{width:'100%', display:'flex',flexDirection:'column',gap:'12px',alignItems:'center'}}>
                    <InputBox type='text' tabIndex={1} onChange={(e)=>setUser_no(e.target.value)} placeholder={`아이디`} onKeyDown={handleKeydown}/>
                    <InputBox type='password' ref={pwdRef} tabIndex={2} onChange={(e)=>setPwd(e.target.value)} placeholder={`비밀번호`} onKeyDown={handleKeydown}/>
                </div>
                <div style={{height:'1rem',textAlign:'center'}}>
                    {comment && 
                        <span>{comment}</span>
                    }
                </div>
                <Button onClick={handleLogin}>Login<img src={`/images/ic_login.svg`} alt='' /></Button>
                <img src={`/images/logo_nb.png`} style={{width: '6rem',margin:'1rem 0rem'}}/>
            </LoginCard>
        </MainWrap>
    )

}

export default Login;